<div class="footer-section">
  <div class="section homepage wf-section">
    <div class="container aboutussignup">
      <div class="align-center">
        <div class="margin-15px">
          <h4 class="hero-title _50px">Try Merchloop Free!<span class="add-scribble-below"></span></h4>
          <div class="margin-15px">
            <p class="sub-heading">The only time you pay is when you sell something! <br></p>
          </div>
        </div>
        <div class="margin-40px">
          <div class="membership">
            <div class="membership-list">
              <div class="check-green"></div>
              <p class="cookies-font">Build your store in minutes</p>
            </div>
            <div class="membership-list">
              <div class="check-green"></div>
              <p class="cookies-font">Always be in stock</p>
            </div>
            <div class="membership-list">
              <div class="check-green"></div>
              <p class="cookies-font">Never worry about collecting sizes again!</p>
            </div>
          </div>
        </div>
        <div class="margin-15px">
          <a (click)="opensignupformDialog()" class="button orange w-button" style="display:inline-block;">Sign Up→</a>
        </div>
        <br />
      </div>

    </div>
  </div>

  <div class="gray-section wf-section">
    <div class="container">
      <div class="align-center">
        <h4 class="hero-title _50px _50-percent">Get in touch with our <span class="add-scribble-below">support</span> team<span class="add-scribble-below"></span><br></h4>
        <div class="margin-20px">
          <p class="sub-heading">Schedule a guided demo<br></p>
        </div>
      </div>
      <div class="margin-10px">
        <div class="w-form">
          <div class="calendly-inline-widget" data-url="https://calendly.com/koakley/merchloop-discovery?primary_color=ff0000" style="min-width:320px;height:650px;"></div>
        </div>
      </div>

      <div class="align-center">
        <h4 class="hero-title _50px _50-percent">
          Subscribe <span class="add-scribble-below">Newsletter</span>
          <span class="add-scribble-below"></span><br>
        </h4>
      </div>
      <div class="margin-30px">
        <div class="w-form">
          <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit(subscribeForm)"  name="email-form" data-name="Email Form" class="form">
            <input formControlName="UserName" type="text"
                   class="text-field w-node-fa825db5-5c3f-a8c6-10d1-888aa5b00c0a-01529649 w-input"
                   maxlength="256"
                   name="UserName"
                   data-name="UserName"
                   placeholder="Enter your name"
                   id="UserName"
                   required="">

            <input formControlName="Email"
                   type="email"
                   class="text-field w-node-fa825db5-5c3f-a8c6-10d1-888aa5b00c0b-01529649 w-input"
                   maxlength="256"
                   name="Email"
                   data-name="Email"
                   placeholder="Enter your email"
                   id="Email"
                   required="">


            <input type="submit" cdkFocusInitial [disabled]="subscribeForm.invalid" value="Subscribe Newsletter →" data-wait="Please wait..." class="button subscribe orange w-button">

            <div *ngIf="!f.UserName.valid && f.UserName.touched && (f.UserName.pristine || f.UserName.dirty)" class="error-message">
              <div>UserName is required.</div>
            </div>

            <div class="error-message" *ngIf="f.Email.touched && f.Email.invalid && f.Email.pristine">
              <div>Email is required.</div>
            </div>
            <div class="error-message" *ngIf="!f.Email.valid && (!f.Email.hasError('pattern') && f.Email.touched && f.Email.dirty)">
              <div>Email is required.</div>
            </div>
            <div class="error-message" *ngIf="!f.Email.valid && (f.Email.hasError('pattern') && f.Email.dirty)">
              <div>Invalid Email Address</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="container">
      <div class="footer-gird">
        <div class="footer-column">
          <a href="" class="footer-logo w-inline-block">
            <img src="assets/img/Merch-Loop4.png" width="145" sizes="145px"
                 srcset="assets/img/Merch-Loop4-p-500.png 500w, assets/img/Merch-Loop4-p-800.png 800w, assets/img/Merch-Loop4-p-1080.png 1080w, assets/img/Merch-Loop4.png 1158w" alt="" class="image">
          </a>
          <div class="margin-25px">
            <p class="paragraph-white">Stores Made Simple</p>
          </div>
          <div class="margin-30px">
            <a (click)="openloginFormDialog()" class="button orange w-button">Sign In / Sign Up→</a>
          </div>
        </div>
        <div class="footer-column">
          <h4 class="footer-title">Useful Links</h4>
          <div class="margin-25px">
            <a href="" class="footer-link">Home</a>
            <a [routerLink]="['/about-us']" class="footer-link">About</a>
            <a [routerLink]="['/why-us']" class="footer-link">Why Us?</a>
            <a [routerLink]="['/features']" class="footer-link">Features</a>
            <a [routerLink]="['/privacy-policy']" class="footer-link">Privacy Policy</a>
            <a [routerLink]="['/terms-of-use']" class="footer-link">Terms &amp; Conditions</a>
            <a [routerLink]="['/contact-us']" class="footer-link">Contact us</a>
          </div>
        </div>
        <div id="w-node-fee1c955-f7ac-8421-1192-b5d2ad448d8f-ad448d73" class="footer-column">
          <h4 class="footer-title">Merchloop HQ</h4>
          <div class="margin-25px">
            <p class="paragraph-white">365 E. Arby Ave <br>Las Vegas, NV 89119<br></p>
          </div>
          <div class="margin-30px usefullink">
            <p class="paragraph">
              <a href="#" class="anchor-underline">hello&#64;merchloop.com</a><br>
            </p>
          </div>
        </div>
        <div class="footer-column">
          <h4 class="footer-title">Follow</h4>
          <div class="margin-25px">
            <div class="social-wrapper left">
              <a href="https://www.facebook.com/Stoked-On-Printing-139438316077946/" class="social-icon only-left w-inline-block"><img src="assets/img/facebook_1facebook.png" width="14" alt=""></a>
              <a href="https://www.youtube.com/channel/UCrcgndGtddtaKIbGQK_hDyg" class="social-icon only-left w-inline-block"><img src="assets/img/YTPlaybutton.png" width="25" alt=""></a>
              <a href="https://www.instagram.com/stokedonprinting/?hl=en" class="social-icon only-left w-inline-block"><img src="assets/img/instagram_1instagram.png" width="15" alt=""></a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-divider"></div>
      <div class="copyright-flex">
        <div class="copyright-dot"></div>
        <p class="copyright">
          Powered by <a href="" target="_blank">Merchloop 2021</a>
        </p>
        <div class="copyright-dot"></div>
      </div>
    </div><img src="assets/img/scribbles-5.png" width="100" sizes="(max-width: 767px) 50px, 100px" srcset="assets/img/scribbles-5-p-500.png 500w, assets/img/scribbles-5.png 642w" alt="" class="scribble-footer">
  </div>
  </div>
